import { ReactNode } from 'react';
import { cx } from '@libs/classnames';
import styles from './LandingSectionTitle.module.css';

type Props = {
  children?: ReactNode;
  className?: string;
  preset?: 'light' | 'dark';
};

export function LandingSectionTitle({
  children,
  className,
  preset = 'light',
}: Props) {
  return (
    <h2 className={cx(styles.root, className, styles[`preset_${preset}`])}>
      <span className={styles.content}>{children}</span>
    </h2>
  );
}
